
// File: HowItsDone.ts
import { HuntrixSong } from './types';

export const HOW_ITS_DONE: HuntrixSong = {
    id: 'HOW_ITS_DONE',
    title: "How It's Done",
    artist: "HUNTR/X",
    midiFileName: "HowItsDone.mid",
    mp3FileName: "HowItsDone.mp3",
    sequencedTracks: [
        {
            "name": "Flute",
            "notes": [
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "0:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "0:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "0:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "0:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "0:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "1:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "1:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "1:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "2:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "2:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "2:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "2:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "2:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "3:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "3:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "3:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "3:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "4:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "4:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "4:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "4:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "4:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "5:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "5:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "5:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "6:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "6:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "6:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "6:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "6:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "7:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "7:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "7:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "7:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "8:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "8:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "8:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "8:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "8:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "9:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "9:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "9:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "10:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "10:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "10:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "10:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "10:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "11:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "11:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "8n",
                    "time": "11:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "12:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "12:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "12:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "12:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "13:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "13:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "13:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "14:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "14:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "15:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "16:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#6",
                    "duration": "8n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "16:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C6",
                    "duration": "8n",
                    "time": "16:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "17:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "17:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F6",
                    "duration": "8n",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#6",
                    "duration": "8n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "18:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#6",
                    "duration": "8n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "18:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C6",
                    "duration": "8n",
                    "time": "18:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "19:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F6",
                    "duration": "8n",
                    "time": "19:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "20:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#6",
                    "duration": "8n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "20:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C6",
                    "duration": "8n",
                    "time": "20:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F6",
                    "duration": "8n",
                    "time": "21:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#6",
                    "duration": "8n",
                    "time": "21:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "22:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#6",
                    "duration": "8n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "22:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "48:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "48:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "48:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "48:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "49:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "49:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "49:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "50:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "50:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "50:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "50:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "50:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "52:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "52:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#6",
                    "duration": "8n",
                    "time": "52:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "52:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C6",
                    "duration": "8n",
                    "time": "52:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "53:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "53:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F6",
                    "duration": "4n",
                    "time": "53:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "54:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "54:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#6",
                    "duration": "8n",
                    "time": "54:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "54:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C6",
                    "duration": "8n",
                    "time": "54:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "55:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "55:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "55:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "56:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "56:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#6",
                    "duration": "8n",
                    "time": "56:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "56:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C6",
                    "duration": "8n",
                    "time": "56:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "57:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "57:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F6",
                    "duration": "4n",
                    "time": "57:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "58:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "58:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#6",
                    "duration": "8n",
                    "time": "58:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "8n",
                    "time": "58:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C6",
                    "duration": "8n",
                    "time": "58:3:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Koto",
            "notes": [
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "0:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "0:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "0:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "0:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "0:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "0:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "0:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "1:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "1:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "1:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "1:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "1:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "1:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "2:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "2:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "2:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "2:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "2:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "2:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "2:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "3:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "3:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "3:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "4:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "4:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "4:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "4:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "4:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "4:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "4:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "5:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "5:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "5:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "5:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "6:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "6:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "6:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "7:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "8:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "8:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "8:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "9:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "9:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "9:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "9:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "9:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "10:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "10:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "10:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "11:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "12:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "12:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "13:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "14:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "39:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "47:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "47:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "47:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "47:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "47:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "47:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.31
                }
            ]
        },
        {
            "name": "2023 Drum Kit",
            "notes": [
                {
                    "name": "A#2",
                    "duration": "4n",
                    "time": "4:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "4n",
                    "time": "6:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "4n",
                    "time": "7:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "4n",
                    "time": "7:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "39:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "39:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "39:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "39:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "48:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "48:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "49:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "49:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "49:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "49:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "50:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "50:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "50:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "50:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "51:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "55:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "55:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "55:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "59:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "59:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "59:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "59:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "59:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "59:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "59:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "59:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "59:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "59:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "59:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "60:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "61:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "61:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "61:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "61:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "62:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "63:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "64:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "65:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "65:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "65:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "65:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "66:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "67:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "67:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "67:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "67:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "67:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "67:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "68:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "68:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "68:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "69:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "69:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "69:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "69:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "69:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "69:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "69:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "69:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "69:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "69:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "69:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "70:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "70:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "70:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "70:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "70:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "70:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "70:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "70:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "70:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "70:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "70:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "71:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "71:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "71:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "71:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "71:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "71:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "71:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "71:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "71:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "71:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "71:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "72:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "72:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "72:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "72:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "72:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "72:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "72:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "72:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "72:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "72:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "72:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "73:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "73:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "73:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "73:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "73:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "73:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "73:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "73:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "73:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "73:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "73:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "73:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "73:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "74:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "74:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "74:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "74:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "74:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "74:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "74:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "74:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "74:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "74:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "74:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "74:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "74:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "75:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "75:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "75:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "75:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "75:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "75:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "75:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "75:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "75:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "75:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "75:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "75:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "76:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "76:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "76:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "76:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "76:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "76:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "76:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "76:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "76:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "76:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "76:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "76:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "76:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "76:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "76:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "76:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "78:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "79:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "79:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "79:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "79:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "80:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "81:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "82:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "83:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "83:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "83:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "83:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "84:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "85:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "85:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "85:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "85:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "85:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "85:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "85:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "85:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "85:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "85:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "1m",
                    "time": "86:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "96:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "96:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "96:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "96:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "96:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "96:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "96:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "96:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "96:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "96:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "97:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "97:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "97:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "97:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "97:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "97:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "97:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "97:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "97:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "97:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "98:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "98:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "98:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "98:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "98:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "98:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "98:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "98:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "98:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "98:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "99:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "99:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "99:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "99:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "99:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "99:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "99:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "99:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "99:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "99:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "100:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "100:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "100:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "100:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "100:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "100:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "100:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "100:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "100:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "100:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "101:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "101:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "101:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "101:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "101:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "101:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "101:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "101:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "101:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "101:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "102:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "102:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "102:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "102:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "102:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "102:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "102:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "102:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "102:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "102:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "103:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "103:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "103:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "103:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "103:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "103:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "103:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "103:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "103:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "103:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "103:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "103:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "104:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "104:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "104:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "104:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "104:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "104:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "104:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "104:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "104:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "104:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "104:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "104:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "105:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "105:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "105:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "105:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "105:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "105:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "105:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "105:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "105:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "105:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "105:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "105:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "105:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "105:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "105:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "106:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "106:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "106:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "106:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "106:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "106:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "106:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "106:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "106:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "106:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "106:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "106:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "107:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "107:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "107:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "107:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "108:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "108:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "108:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "108:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "108:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "108:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "108:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "108:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "108:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "108:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "108:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "108:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "109:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "109:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "109:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "109:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "109:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "109:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "109:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "109:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "109:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "109:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "109:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "109:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "109:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "109:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "109:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "110:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "110:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "110:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "110:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "110:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "110:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "110:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "110:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "110:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "110:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "110:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "110:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "111:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "111:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "111:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "111:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "111:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "111:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "111:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "111:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "111:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "1m",
                    "time": "112:0:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "808 Drum Kit",
            "notes": [
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "8:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "8:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "9:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "9:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "9:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "10:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "10:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "11:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "11:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "11:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "12:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "13:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "14:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "15:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "16:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "17:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "17:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "18:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "19:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "20:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "21:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "22:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "25:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "25:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "26:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "27:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "28:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "28:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "28:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "29:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "29:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "29:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "32:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "33:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "42:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "42:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "42:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "42:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "42:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "43:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "43:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "43:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "44:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "44:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "44:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "44:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "44:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "45:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "45:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "45:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "45:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "46:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "46:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "46:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "46:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "46:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "47:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "47:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "47:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "52:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "52:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "52:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "52:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "53:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "53:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "53:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "53:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "54:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "54:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "54:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "54:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "56:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "56:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "56:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "56:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "57:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "57:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "57:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "57:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "58:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "58:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "58:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "58:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "60:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "60:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "61:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "61:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "62:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "62:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "63:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "63:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "64:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "64:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "65:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "65:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "66:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "66:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "67:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "67:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "68:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "68:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "69:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "69:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "70:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "70:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "71:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "71:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "71:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "72:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "72:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "73:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "73:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "74:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "74:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "75:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "75:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "76:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "76:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "78:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "78:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "79:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "79:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "80:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "80:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "81:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "81:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "82:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "82:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "83:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "83:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "84:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "84:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "85:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "85:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "86:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "86:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "87:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "87:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "88:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "88:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "89:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "89:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "90:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "90:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "90:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "90:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "91:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "91:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "91:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "91:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "92:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "92:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "92:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "92:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "93:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "93:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "93:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "93:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "96:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "96:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "97:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "97:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "98:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "98:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "99:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "99:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "100:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "100:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "101:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "101:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "102:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "102:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "103:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "104:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "105:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "106:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "107:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "108:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "109:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "110:1:0",
                    "velocity": 0.2
                }
            ]
        },
        {
            "name": "Mira",
            "notes": [
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "12:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "12:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "12:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "12:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "12:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "12:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "13:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "13:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "13:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "13:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "13:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "13:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "13:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "14:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "14:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "14:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "14:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "14:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "14:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "14:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "15:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "15:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "15:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "15:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "24:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "24:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "24:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "4n",
                    "time": "25:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "25:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "25:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "25:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "25:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "26:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "28:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "28:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "28:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "4n",
                    "time": "29:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "29:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "29:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "29:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "29:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "54:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "54:0:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "54:0:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "54:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "54:1:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "54:1:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "54:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "54:2:1",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "54:2:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "54:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "54:3:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "54:3:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "55:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "55:0:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "55:0:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "55:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "55:1:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "55:1:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "55:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G5",
                    "duration": "4n",
                    "time": "55:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "62:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "62:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "62:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "62:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "63:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "63:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "63:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "63:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "70:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "70:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "71:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "71:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "71:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "71:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "71:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "72:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "74:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "8n",
                    "time": "74:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "74:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "74:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "74:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "78:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "78:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "78:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "78:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "78:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "79:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "79:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "79:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "79:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "79:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "80:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "80:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "80:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "80:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "80:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "81:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "81:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "81:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "96:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "96:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "96:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "97:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "8n",
                    "time": "97:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "97:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "97:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "100:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "100:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "100:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "100:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "101:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "8n",
                    "time": "101:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "101:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "101:3:0",
                    "velocity": 0.5
                }
            ]
        },
        {
            "name": "Zoey",
            "notes": [
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "16:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "16:0:2",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "16:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "16:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "16:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "16:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "16:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "16:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "17:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "17:0:2",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "17:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "17:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "17:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "17:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "17:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "17:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "18:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "18:0:2",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "18:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "18:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "18:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "18:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "18:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "18:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "19:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "19:0:2",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "19:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "19:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "19:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "19:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "19:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "19:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "20:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "20:1:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "20:1:3",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "20:2:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "20:2:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "20:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "20:3:3",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "21:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "21:1:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "21:1:3",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "21:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "21:2:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "21:2:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "21:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "21:3:3",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "22:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "22:0:3",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "22:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "22:1:3",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "22:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "22:2:3",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "22:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "22:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "23:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "23:0:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "23:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "23:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "23:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "23:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "23:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "23:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "55:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "55:3:1",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "55:3:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "56:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "56:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "56:1:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "56:1:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "56:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "56:2:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "56:2:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "56:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "56:3:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "56:3:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "57:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "57:0:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "57:0:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "57:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "57:1:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "57:1:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "57:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "57:2:1",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "57:2:3",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "57:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "64:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "64:0:3",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "64:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "64:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "4n",
                    "time": "64:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "64:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "64:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "65:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "4n",
                    "time": "65:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "65:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "65:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "65:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "66:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "66:0:2",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "66:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "66:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "66:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "66:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "4n",
                    "time": "66:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "67:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "67:0:2",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "67:0:3",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "67:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "67:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "67:2:3",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "2n",
                    "time": "67:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "75:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "75:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "75:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "75:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "1m",
                    "time": "75:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "82:0:2",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "82:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "82:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "82:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "82:2:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "82:2:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "82:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "82:3:3",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "83:0:2",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "83:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "83:1:1",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "83:1:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "83:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "83:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "83:2:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "83:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "83:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "84:0:2",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "84:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "84:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "84:1:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "84:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "84:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "84:2:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "84:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "84:3:3",
                    "velocity": 0.5
                }
            ]
        },
        {
            "name": "Bass",
            "notes": [
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "4:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "5:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "6:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "8:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "9:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "10:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "11:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "11:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "12:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "13:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "14:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "14:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "15:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "15:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "16:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "17:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "18:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "19:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "19:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "20:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "21:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "22:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "23:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "23:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "32:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "32:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "32:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "33:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "2n",
                    "time": "33:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "34:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "34:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "35:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "35:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "F2",
                    "duration": "4n",
                    "time": "35:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "36:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "36:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "36:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "37:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "2n",
                    "time": "37:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "38:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A#2",
                    "duration": "4n",
                    "time": "38:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "39:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "39:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "40:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "40:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "40:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "41:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "2n",
                    "time": "41:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "42:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "42:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "43:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "43:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "F2",
                    "duration": "4n",
                    "time": "43:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "44:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "44:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "44:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "45:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "2n",
                    "time": "45:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "46:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A#2",
                    "duration": "4n",
                    "time": "46:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "47:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "47:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "48:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "49:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "50:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "51:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "51:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "52:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "53:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "54:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "55:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "55:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "55:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "56:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "57:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "58:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "60:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "4n",
                    "time": "60:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "60:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "60:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "61:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "F2",
                    "duration": "8n",
                    "time": "61:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "61:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "62:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "4n",
                    "time": "62:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "62:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "62:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "63:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "63:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "64:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "4n",
                    "time": "64:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "64:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "64:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "65:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "F2",
                    "duration": "8n",
                    "time": "65:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "65:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "2n",
                    "time": "66:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A#2",
                    "duration": "2n",
                    "time": "66:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "78:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "4n",
                    "time": "78:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "78:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "78:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "79:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "F2",
                    "duration": "8n",
                    "time": "79:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "79:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "80:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "4n",
                    "time": "80:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "80:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "80:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "81:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "81:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "82:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "4n",
                    "time": "82:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "82:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "82:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "83:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "F2",
                    "duration": "8n",
                    "time": "83:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "83:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "2n",
                    "time": "84:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A#2",
                    "duration": "2n",
                    "time": "84:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "96:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C2",
                    "duration": "4n",
                    "time": "97:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "97:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "98:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C2",
                    "duration": "4n",
                    "time": "99:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "99:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "100:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C2",
                    "duration": "4n",
                    "time": "101:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "101:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "102:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C2",
                    "duration": "4n",
                    "time": "103:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "103:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "104:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "1m",
                    "time": "105:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "106:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "107:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C2",
                    "duration": "4n",
                    "time": "107:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "G2",
                    "duration": "4n",
                    "time": "107:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "108:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "1m",
                    "time": "109:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "110:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "111:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C2",
                    "duration": "4n",
                    "time": "111:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "G2",
                    "duration": "4n",
                    "time": "111:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D2",
                    "duration": "4n",
                    "time": "112:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "114:3:3",
                    "velocity": 0.2
                }
            ]
        },
        {
            "name": "EDM Kit (E)",
            "notes": [
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "4:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "5:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "6:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "7:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "7:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "7:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "8:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "9:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "10:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "11:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "11:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "12:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "13:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "14:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "15:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "17:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "19:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "32:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "32:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "33:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "33:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "34:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "35:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "36:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "36:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "38:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "40:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "40:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "41:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "42:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "42:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "43:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "43:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "44:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "44:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "44:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "45:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "45:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "46:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "46:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "49:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "50:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "51:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "51:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "52:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "53:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "54:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "55:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "56:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "57:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "58:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "58:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "60:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "60:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "61:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "61:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "61:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "62:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "62:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "63:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "63:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "63:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "64:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "64:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "64:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "65:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "65:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "65:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "66:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "66:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "67:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "67:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "71:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "71:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "72:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "72:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "73:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "73:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "74:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "74:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "74:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "74:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "75:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "75:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "75:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "75:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "76:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "76:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "76:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "76:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "76:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "76:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "76:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "76:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "78:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "78:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "78:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "79:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "79:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "79:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "80:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "80:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "81:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "81:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "81:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "82:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "82:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "82:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "83:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "83:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "83:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "84:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "84:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "85:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "85:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "90:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "90:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "91:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "91:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "92:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "92:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "92:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "92:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "93:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "93:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "93:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "93:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "93:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "93:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "93:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "93:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "95:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "95:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "96:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "96:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "97:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "97:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "97:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "97:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "98:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "98:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "99:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "99:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "99:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "99:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "100:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "100:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "101:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "101:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "101:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "101:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "102:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "102:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "104:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "104:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "104:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "104:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "105:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "105:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "105:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "105:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "105:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "105:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "106:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "106:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "106:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "106:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "107:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "107:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "107:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "107:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "107:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "108:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "108:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "108:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "108:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "109:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "109:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "109:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "109:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "109:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "109:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "110:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "110:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "110:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "110:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "111:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "111:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "111:3:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "808 Bass",
            "notes": [
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "4:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "9:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "33:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "42:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "42:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "43:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "43:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "44:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "44:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "44:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "45:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "45:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "46:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "46:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "47:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "47:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "49:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "52:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "53:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "54:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "55:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "55:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "55:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "56:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "57:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "58:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "60:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "60:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "60:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "60:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "62:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "62:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "62:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "62:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "64:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "64:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "64:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "64:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "66:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "66:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "78:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "78:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "78:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "78:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "79:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "79:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "79:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "80:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "80:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "80:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "80:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "81:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "81:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "82:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "82:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "82:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "82:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "83:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "83:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "83:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "84:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "96:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "97:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "97:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "98:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "99:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "99:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "100:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "101:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "101:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "102:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "103:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "103:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "104:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "105:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "106:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "107:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "107:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "107:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "108:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "109:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "110:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "111:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "111:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "111:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "112:0:0",
                    "velocity": 0.2
                }
            ]
        },
        {
            "name": "Pizzicato",
            "notes": [
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "16:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "16:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "17:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "20:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "21:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "21:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "22:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "24:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "25:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "25:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "25:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "25:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "26:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "27:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "27:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "28:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "28:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "29:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "29:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "30:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "48:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "48:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "48:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "48:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "49:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "49:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "49:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "49:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "49:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "49:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "50:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "50:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "50:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "50:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "50:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "52:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "52:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "52:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "52:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "52:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "52:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "53:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "53:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "53:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "53:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "53:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "53:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "54:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "54:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "54:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "54:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "54:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "54:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "55:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "55:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "55:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "56:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "56:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "56:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "56:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "56:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "56:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "57:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "57:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "57:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "57:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "57:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "57:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "58:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "58:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "58:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "58:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "58:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "58:3:2",
                    "velocity": 0.27
                }
            ]
        },
        {
            "name": "Grand Piano",
            "notes": [
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "8n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "27:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "27:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "27:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "8n",
                    "time": "30:0:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Smooth Synth",
            "notes": [
                {
                    "name": "D1",
                    "duration": "1m",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "1m",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "1m",
                    "time": "27:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D1",
                    "duration": "1m",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "1m",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D1",
                    "duration": "1m",
                    "time": "68:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "1m",
                    "time": "70:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "1m",
                    "time": "71:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D1",
                    "duration": "1m",
                    "time": "72:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "1m",
                    "time": "74:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#0",
                    "duration": "1m",
                    "time": "86:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G0",
                    "duration": "1m",
                    "time": "87:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C1",
                    "duration": "1m",
                    "time": "88:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A0",
                    "duration": "1m",
                    "time": "89:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#0",
                    "duration": "1m",
                    "time": "90:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G0",
                    "duration": "1m",
                    "time": "91:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C1",
                    "duration": "1m",
                    "time": "92:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A0",
                    "duration": "1m",
                    "time": "93:0:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Orchestra Hit",
            "notes": [
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "31:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "31:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "38:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "38:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "39:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "39:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "46:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "46:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "46:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "47:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "47:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "4n",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "4n",
                    "time": "60:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "4n",
                    "time": "62:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "4n",
                    "time": "62:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "4n",
                    "time": "64:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "4n",
                    "time": "64:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "4n",
                    "time": "66:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "4n",
                    "time": "66:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "77:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "77:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "78:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "81:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "81:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "82:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "4n",
                    "time": "84:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "4n",
                    "time": "84:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "95:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "95:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "96:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "99:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "99:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "100:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "103:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "103:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "103:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "104:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "107:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "107:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "108:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "111:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "111:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "8n",
                    "time": "112:0:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Steel Drums",
            "notes": [
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "25:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "25:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "27:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "29:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Electric Piano (All)",
            "notes": [
                {
                    "name": "A#4",
                    "duration": "8n",
                    "time": "26:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "26:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "26:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "8n",
                    "time": "27:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "27:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "27:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "27:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "28:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "28:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "28:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "29:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "29:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "29:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "30:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#3",
                    "duration": "4n",
                    "time": "30:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#5",
                    "duration": "4n",
                    "time": "30:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "8n",
                    "time": "30:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "30:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#5",
                    "duration": "8n",
                    "time": "30:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "30:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "30:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A5",
                    "duration": "8n",
                    "time": "30:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "30:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "30:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G5",
                    "duration": "4n",
                    "time": "30:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "4n",
                    "time": "30:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F3",
                    "duration": "4n",
                    "time": "30:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "30:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "31:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "C3",
                    "duration": "4n",
                    "time": "31:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "31:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#5",
                    "duration": "4n",
                    "time": "31:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#3",
                    "duration": "4n",
                    "time": "31:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "31:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "32:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "32:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "32:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "34:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "34:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "34:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "34:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "34:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "34:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "34:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "34:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "34:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "34:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "34:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "34:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "35:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "35:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "35:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "35:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "35:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "35:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "35:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "35:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "35:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "35:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#5",
                    "duration": "4n",
                    "time": "35:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "35:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "36:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "36:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "36:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "38:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "38:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "38:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "38:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "38:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "38:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "38:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "38:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "38:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "38:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "38:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "38:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "39:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "39:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "39:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "39:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "39:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "39:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "39:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "39:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "39:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "39:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#5",
                    "duration": "4n",
                    "time": "39:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "39:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "40:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "40:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "40:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "40:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "40:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "40:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "41:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "8n",
                    "time": "41:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "41:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "41:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "42:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "42:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "42:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "42:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "43:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "8n",
                    "time": "43:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "43:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "43:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "44:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "44:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "44:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "44:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "45:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "8n",
                    "time": "45:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "45:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "45:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "46:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "46:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "46:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "46:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "46:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "46:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "46:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "46:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "46:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "46:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "46:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "46:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "47:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "47:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "47:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "47:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "47:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "47:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "47:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "47:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "47:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "47:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#5",
                    "duration": "4n",
                    "time": "47:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "47:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "48:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "48:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "48:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "70:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "70:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "70:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "8n",
                    "time": "71:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "71:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "71:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "71:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "72:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "72:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "72:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "73:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "73:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "73:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "77:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "77:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "77:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "77:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "77:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "C3",
                    "duration": "4n",
                    "time": "77:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "77:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#5",
                    "duration": "4n",
                    "time": "77:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#3",
                    "duration": "4n",
                    "time": "77:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "77:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "78:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "78:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "78:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "81:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "81:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "81:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "81:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "81:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "81:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "81:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "81:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#5",
                    "duration": "4n",
                    "time": "81:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "81:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "82:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "82:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "82:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "85:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "85:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "85:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "85:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "85:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "85:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "85:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "85:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#5",
                    "duration": "4n",
                    "time": "85:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "85:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "86:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "86:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "86:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "95:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "95:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "95:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "95:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "95:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "95:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "95:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "C3",
                    "duration": "4n",
                    "time": "95:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "95:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "95:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#5",
                    "duration": "4n",
                    "time": "95:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#3",
                    "duration": "4n",
                    "time": "95:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "95:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "95:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "96:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "96:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "96:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "96:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "102:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "102:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "102:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "102:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "102:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "102:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "102:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "102:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "102:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "102:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "102:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "102:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "103:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "103:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "103:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "103:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "103:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "103:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "103:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "103:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "103:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#3",
                    "duration": "4n",
                    "time": "103:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "104:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "104:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "104:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "104:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "104:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "104:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "104:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "104:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "104:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "105:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "105:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "105:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "105:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "105:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "105:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "105:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "106:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "106:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "106:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "106:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "106:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "106:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "106:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "106:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "107:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "107:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "107:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "2n",
                    "time": "107:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "108:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "108:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "108:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "108:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "108:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "108:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "108:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "108:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "109:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "109:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "2n",
                    "time": "109:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "2n",
                    "time": "109:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "110:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "110:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "110:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "110:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "110:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "110:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "110:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "110:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "110:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "110:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "110:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "110:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "110:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "110:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "111:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "111:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "111:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "111:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "111:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "111:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "111:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "111:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "111:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#3",
                    "duration": "4n",
                    "time": "111:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "112:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "112:0:0",
                    "velocity": 0.5
                }
            ]
        },
        {
            "name": "8-Bit Sawtooth",
            "notes": [
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "32:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "32:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "32:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "33:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "33:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "33:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "34:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "34:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "34:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "35:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "35:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "35:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "35:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "36:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "36:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "36:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "37:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "37:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "37:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "40:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "40:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "40:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "41:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "41:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "41:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "42:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "42:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "42:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "43:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "43:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "43:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "43:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "44:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "44:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "44:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "45:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "45:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "45:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "60:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "60:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "61:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "61:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D#3",
                    "duration": "4n",
                    "time": "61:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "62:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "62:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "63:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#3",
                    "duration": "4n",
                    "time": "63:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "64:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "64:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "65:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "65:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D#3",
                    "duration": "4n",
                    "time": "65:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "2n",
                    "time": "66:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#3",
                    "duration": "2n",
                    "time": "66:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "78:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "78:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "79:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "79:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D#3",
                    "duration": "4n",
                    "time": "79:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "80:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "80:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "81:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#3",
                    "duration": "4n",
                    "time": "81:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "82:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "82:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "83:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "83:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D#3",
                    "duration": "4n",
                    "time": "83:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "2n",
                    "time": "84:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#3",
                    "duration": "2n",
                    "time": "84:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "96:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "96:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "96:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "96:2:3",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "96:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "97:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "97:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "97:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "97:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "97:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "98:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "98:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "98:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "98:2:3",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "98:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "99:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "4n",
                    "time": "99:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "99:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "99:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "100:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "100:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "100:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "100:2:3",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "100:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "101:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "101:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "101:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "101:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "101:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "102:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "102:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "102:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "102:2:3",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "102:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "103:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "103:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "104:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "104:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "104:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "104:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "104:2:3",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "104:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "105:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "105:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "105:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "105:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "105:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "105:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "106:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "106:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "106:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "106:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "106:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "106:2:3",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "106:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "107:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "107:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "107:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "107:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "108:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "108:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "108:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "108:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "108:2:3",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "108:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "109:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "109:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "109:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "109:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "109:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "109:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "110:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "110:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "110:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "110:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "110:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "110:2:3",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "110:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "111:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "111:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "111:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "112:0:0",
                    "velocity": 0.27
                }
            ]
        },
        {
            "name": "Muted E-Guitar",
            "notes": [
                {
                    "name": "D4",
                    "duration": "2n",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "2n",
                    "time": "60:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "2n",
                    "time": "62:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "2n",
                    "time": "62:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "2n",
                    "time": "64:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "2n",
                    "time": "64:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "2n",
                    "time": "66:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "2n",
                    "time": "66:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "2n",
                    "time": "78:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "2n",
                    "time": "78:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "2n",
                    "time": "80:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "2n",
                    "time": "80:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "2n",
                    "time": "82:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "2n",
                    "time": "82:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "2n",
                    "time": "84:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "2n",
                    "time": "84:3:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Xylophone",
            "notes": [
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "68:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "68:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "68:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "68:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "68:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "68:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "69:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "69:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "69:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "69:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "69:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "69:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "70:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "70:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "70:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "70:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "70:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "70:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "71:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "71:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "71:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "71:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "71:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "71:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "72:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "72:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "72:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "72:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "72:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "72:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "73:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "73:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "73:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "73:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "73:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "73:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "74:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "74:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "74:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "74:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "74:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "74:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "75:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "75:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "75:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "75:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "75:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "75:3:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Violin",
            "notes": [
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "68:0:0",
                    "velocity": 0.06
                },
                {
                    "name": "D5",
                    "duration": "1m",
                    "time": "68:0:0",
                    "velocity": 0.06
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "70:0:0",
                    "velocity": 0.06
                },
                {
                    "name": "G5",
                    "duration": "1m",
                    "time": "70:0:0",
                    "velocity": 0.06
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "71:0:0",
                    "velocity": 0.06
                },
                {
                    "name": "A#5",
                    "duration": "1m",
                    "time": "71:0:0",
                    "velocity": 0.06
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "72:0:0",
                    "velocity": 0.06
                },
                {
                    "name": "D5",
                    "duration": "1m",
                    "time": "72:0:0",
                    "velocity": 0.06
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "74:0:0",
                    "velocity": 0.06
                },
                {
                    "name": "G5",
                    "duration": "1m",
                    "time": "74:0:0",
                    "velocity": 0.06
                },
                {
                    "name": "D6",
                    "duration": "1m",
                    "time": "75:0:0",
                    "velocity": 0.06
                },
                {
                    "name": "G6",
                    "duration": "1m",
                    "time": "76:0:0",
                    "velocity": 0.06
                }
            ]
        },
        {
            "name": "Synthesizer",
            "notes": [
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "68:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A2",
                    "duration": "1m",
                    "time": "68:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F3",
                    "duration": "1m",
                    "time": "68:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "70:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A#2",
                    "duration": "1m",
                    "time": "70:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "70:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A#3",
                    "duration": "1m",
                    "time": "71:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "71:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "71:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "72:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A2",
                    "duration": "1m",
                    "time": "72:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F3",
                    "duration": "1m",
                    "time": "72:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "74:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A#2",
                    "duration": "1m",
                    "time": "74:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "74:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "86:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A#2",
                    "duration": "1m",
                    "time": "86:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F2",
                    "duration": "1m",
                    "time": "86:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A#2",
                    "duration": "1m",
                    "time": "87:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "87:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G2",
                    "duration": "1m",
                    "time": "87:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E2",
                    "duration": "1m",
                    "time": "88:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G2",
                    "duration": "1m",
                    "time": "88:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "88:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E2",
                    "duration": "1m",
                    "time": "89:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A2",
                    "duration": "1m",
                    "time": "89:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "89:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "90:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A#2",
                    "duration": "1m",
                    "time": "90:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F2",
                    "duration": "1m",
                    "time": "90:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "90:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "2n",
                    "time": "90:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "A#2",
                    "duration": "1m",
                    "time": "91:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "91:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G2",
                    "duration": "1m",
                    "time": "91:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F4",
                    "duration": "2n",
                    "time": "91:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "91:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "E2",
                    "duration": "1m",
                    "time": "92:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G2",
                    "duration": "1m",
                    "time": "92:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "92:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E2",
                    "duration": "1m",
                    "time": "93:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A2",
                    "duration": "1m",
                    "time": "93:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "93:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A4",
                    "duration": "1m",
                    "time": "93:0:0",
                    "velocity": 0.24
                }
            ]
        },
        {
            "name": "Rumi",
            "notes": [
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "8:1:1",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "8:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "8:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "8:3:1",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "8:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "9:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "9:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "9:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "9:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "9:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "9:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "9:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "10:1:1",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "10:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "10:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "10:3:1",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "10:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "11:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "11:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "11:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "11:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "11:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "11:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "11:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "26:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "26:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "27:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "27:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "27:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "27:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "27:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "28:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "31:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "31:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "31:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "31:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "32:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "4n",
                    "time": "51:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "52:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "52:1:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "52:1:3",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "52:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "52:2:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "52:2:3",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "52:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "52:3:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "52:3:3",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "53:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "53:0:1",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "53:0:3",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "53:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "53:1:3",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "4n",
                    "time": "53:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "53:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "58:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "58:0:1",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "58:0:3",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "58:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "58:1:3",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "58:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "58:2:1",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "58:2:3",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "58:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "58:3:1",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "58:3:3",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "59:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "59:0:1",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "59:0:3",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "59:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "59:1:1",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "59:1:3",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "59:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "59:2:1",
                    "velocity": 0.5
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "59:2:3",
                    "velocity": 0.5
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "59:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "60:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "4n",
                    "time": "60:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "60:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "60:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "4n",
                    "time": "60:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "60:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "61:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "61:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "61:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "61:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "61:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "61:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "68:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "68:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "68:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "4n",
                    "time": "69:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "69:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "69:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "69:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "69:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "8n",
                    "time": "70:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "72:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "72:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "72:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "4n",
                    "time": "73:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "73:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "73:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "73:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "73:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "G5",
                    "duration": "4n",
                    "time": "76:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "76:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "76:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "G5",
                    "duration": "4n",
                    "time": "76:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A5",
                    "duration": "4n",
                    "time": "76:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "77:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "77:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "77:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "77:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "78:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "86:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "86:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "87:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "4n",
                    "time": "87:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "87:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "87:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "87:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "88:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "88:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "89:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "4n",
                    "time": "89:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "89:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "89:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "89:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "90:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "90:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "91:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "4n",
                    "time": "91:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "91:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "91:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "91:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "92:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "92:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "93:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "93:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "93:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "94:0:2",
                    "velocity": 0.5
                },
                {
                    "name": "G5",
                    "duration": "1m",
                    "time": "94:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A5",
                    "duration": "2n",
                    "time": "96:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "98:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "98:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "98:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "98:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "99:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "8n",
                    "time": "99:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "99:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "99:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "107:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "107:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "108:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D5",
                    "duration": "2n",
                    "time": "108:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "109:1:0",
                    "velocity": 0.5
                },
                {
                    "name": "G5",
                    "duration": "4n",
                    "time": "109:1:2",
                    "velocity": 0.5
                },
                {
                    "name": "G5",
                    "duration": "4n",
                    "time": "109:2:2",
                    "velocity": 0.5
                },
                {
                    "name": "A5",
                    "duration": "2n",
                    "time": "109:3:2",
                    "velocity": 0.5
                },
                {
                    "name": "D6",
                    "duration": "1m",
                    "time": "110:3:0",
                    "velocity": 0.5
                }
            ]
        },
        {
            "name": "Synth Pluck",
            "notes": [
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "86:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "86:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "86:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "86:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "86:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "86:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "86:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "86:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "86:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "86:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "86:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "86:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "86:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "86:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "86:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "86:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "86:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "86:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "86:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "86:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "86:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "86:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "86:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "86:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "87:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "87:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "87:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "87:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "87:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "87:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "87:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "87:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "87:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "87:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "87:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "87:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "87:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "87:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "87:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "87:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "87:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "87:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "87:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "87:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "87:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "87:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "87:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "87:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "88:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "88:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "88:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "88:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "88:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "88:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "88:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "88:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "88:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "88:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "88:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "88:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "88:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "88:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "88:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "88:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "88:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "88:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "88:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "88:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "88:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "88:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "88:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "88:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "89:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "89:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "89:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "89:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "89:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "89:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "89:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "89:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "89:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "89:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "89:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "89:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "89:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "89:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "89:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "89:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "89:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "89:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "89:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "89:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "89:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "89:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "89:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "89:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "90:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "90:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "90:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "90:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "90:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "90:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "90:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "90:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "90:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "90:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "90:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "90:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "90:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "90:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "90:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "90:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "90:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "90:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "90:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "90:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "90:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "90:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "90:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "90:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "91:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "91:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "91:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "91:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "91:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "91:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "91:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "91:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "91:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "91:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "91:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "91:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "91:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "91:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "91:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "91:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "91:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "91:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "91:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "91:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "91:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "91:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "91:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "91:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "92:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "92:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "92:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "92:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "92:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "92:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "92:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "92:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "92:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "92:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "92:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "92:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "92:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "92:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "92:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "92:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "92:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "92:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "92:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "92:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "92:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "92:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "92:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "92:3:2",
                    "velocity": 0.12
                }
            ]
        },
        {
            "name": "8-Bit Square",
            "notes": [
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "32:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "32:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "32:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "33:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "33:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "33:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "34:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "34:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "34:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "35:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "35:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "35:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "35:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "36:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "36:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "36:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "37:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "37:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "37:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "40:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "40:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "40:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "41:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "41:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "41:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "42:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "42:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "42:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "43:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "43:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "43:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "43:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "44:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "44:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "44:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "45:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "45:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "45:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "96:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "96:1:3",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "96:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "96:2:3",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "96:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "4n",
                    "time": "97:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "97:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "97:1:3",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "4n",
                    "time": "97:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "97:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "98:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "98:1:3",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "98:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "98:2:3",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "98:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "4n",
                    "time": "99:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "4n",
                    "time": "99:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "4n",
                    "time": "99:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "4n",
                    "time": "99:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "100:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "100:1:3",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "100:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "100:2:3",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "100:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "4n",
                    "time": "101:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "101:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "101:1:3",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "4n",
                    "time": "101:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "101:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "102:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "102:1:3",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "102:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "102:2:3",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "102:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "103:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "103:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "104:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "104:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "104:1:3",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "104:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "104:2:3",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "104:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "4n",
                    "time": "105:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "105:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "105:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "105:1:3",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "4n",
                    "time": "105:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "105:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "106:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "106:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "106:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "106:1:3",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "106:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "106:2:3",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "106:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "107:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "107:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "107:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "107:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "108:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "108:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "108:1:3",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "108:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "108:2:3",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "108:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "4n",
                    "time": "109:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "109:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "109:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "109:1:3",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "4n",
                    "time": "109:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "109:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "110:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "110:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "110:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "110:1:3",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "110:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "110:2:3",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "110:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "111:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "111:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "111:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "112:0:0",
                    "velocity": 0.16
                }
            ]
        },
        {
            "name": "Brass",
            "notes": [
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "7:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "50:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "51:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "51:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "52:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "54:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "58:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "2n",
                    "time": "60:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "61:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "8n",
                    "time": "61:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "61:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "62:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "2n",
                    "time": "62:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "63:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "63:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "64:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "2n",
                    "time": "64:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "65:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "8n",
                    "time": "65:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "65:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "2n",
                    "time": "66:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "2n",
                    "time": "66:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "77:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "77:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "78:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "78:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "2n",
                    "time": "78:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "79:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "8n",
                    "time": "79:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "79:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "80:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "2n",
                    "time": "80:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "81:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "81:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "82:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "2n",
                    "time": "82:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "83:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "8n",
                    "time": "83:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "4n",
                    "time": "83:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "2n",
                    "time": "84:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "2n",
                    "time": "84:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "85:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "85:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "86:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "2n",
                    "time": "90:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "95:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "95:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "96:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "99:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "99:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "100:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "103:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "103:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "104:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "107:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "107:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "108:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "111:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "111:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "112:0:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Strings",
            "notes": [
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "7:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "50:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "51:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "51:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "52:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "54:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "56:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "58:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "77:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "77:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "78:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "85:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "85:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "86:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "95:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "95:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "96:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "99:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "99:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "100:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "103:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "103:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "104:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "107:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "107:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "108:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "111:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "111:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "112:0:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Boom",
            "notes": [
                {
                    "name": "D#1",
                    "duration": "1m",
                    "time": "112:0:0",
                    "velocity": 0.27
                }
            ]
        },
        {
            "name": "Crowd",
            "notes": [
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "97:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "97:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "97:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "97:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "97:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "97:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "98:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "98:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "98:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "99:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "99:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "99:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "99:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "99:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "99:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "100:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "100:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "100:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "101:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "101:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "101:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "101:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "101:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "101:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "102:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "102:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "102:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "103:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "103:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "103:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "103:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "103:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "103:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "104:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "104:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "104:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "105:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "105:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "105:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "105:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "105:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "105:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "106:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "106:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "106:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "107:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "107:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "107:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "107:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "107:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "107:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "108:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "108:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "108:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "109:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "109:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "109:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "109:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "109:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "109:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "110:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "110:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "110:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "111:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "111:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "111:2:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "111:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "111:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "111:3:0",
                    "velocity": 0.5
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "112:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "112:0:0",
                    "velocity": 0.5
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "112:0:0",
                    "velocity": 0.5
                }
            ]
        }
    ],
    structure: [
        { 
            type: 'INTRO', 
            duration: 16, 
            rhythm: 'TRAP', 
            singer: 'RUMI',
            lyrics: [
                "Ugh, you came at a bad time", 
                "But you just crossed the line", 
                "You wanna get wild?", 
                "Okay, I'll show you wild"
            ]
        },
        { 
            type: 'VERSE', 
            duration: 8, 
            rhythm: 'TRAP', 
            singer: 'RUMI',
            lyrics: [
                "Better come right, better luck trying gettin' to our level!",
                "'Cause you might die, never the time. Tryin' to start a battle!",
                "Bleeding isn't in my blood! Ppyeosokbuteo dalaseo!"
            ]
        },
        { 
            type: 'VERSE', 
            duration: 4, 
            rhythm: 'TRAP', 
            singer: 'MIRA',
            lyrics: [
                "Beating you is what I do, do, do, yeah!"
            ]
        },
        { 
            type: 'VERSE', 
            duration: 20, 
            rhythm: 'TRAP', 
            singer: 'ZOEY',
            lyrics: [
                "Body on body. I'm naughty, not even sorry!",
                "When you pull up, I'll pull up a little late to the party! Nah, nah!",
                "Locked, loaded, born for this! No point in avoiding it!",
                "Annoyed a bit? Bureul bichwo! Da bikyeo ni ap gireul bbaetgyeo!"
            ]
        },
        { 
            type: 'PRE_CHORUS', 
            duration: 16, 
            rhythm: 'BUILDUP', 
            singer: 'ALL',
            lyrics: [
                "Knocking you out like a lullaby!",
                "Hear that sound ringing in your mind!",
                "Better sit down for the show!",
                "'Cause I'm gonna show you how it's done, done, done!"
            ]
        },
        { 
            type: 'CHORUS', 
            duration: 32, 
            rhythm: 'TRAP', 
            singer: 'ALL',
            lyrics: [
                "HUNTR/X don't miss how it's done, done, done!",
                "Hey! HUNTR/X don't quit how it's done, done, done!",
                "Run, run, we run the town! Whole world playing our sound!",
                "Turning up, it's going down! HUNTR/X show this",
                "How it's done, done, done!"
            ]
        },
        { 
            type: 'RAP_VERSE', 
            duration: 4, 
            rhythm: 'TRAP', 
            singer: 'RUMI',
            lyrics: ["Something about when you come for the crown that's so humbling."]
        },
        { 
            type: 'RAP_VERSE', 
            duration: 4, 
            rhythm: 'TRAP', 
            singer: 'MIRA',
            lyrics: ["Gapiagi wai geurae? Meonjeo geondeuryeo Wae? Ijeya pogi hae, what?"]
        },
        { 
            type: 'RAP_VERSE', 
            duration: 4, 
            rhythm: 'TRAP', 
            singer: 'ZOEY',
            lyrics: ["Run up, you're done up! From sun up to sundown, so come play!"]
        },
        { 
            type: 'RAP_VERSE', 
            duration: 4, 
            rhythm: 'TRAP', 
            singer: 'RUMI',
            lyrics: ["Won either way, one in a million We kill! Want it? Okay! Heels, nails, blade, mascara!"]
        },
        { 
            type: 'RAP_VERSE', 
            duration: 4, 
            rhythm: 'TRAP', 
            singer: 'MIRA',
            lyrics: ["Fit check for my napalm era!"]
        },
        { 
            type: 'RAP_VERSE', 
            duration: 12, 
            rhythm: 'TRAP', 
            singer: 'ZOEY',
            lyrics: [
                "Need to beat my face. Make it cute and savage!",
                "Mirror, mirror on my phone Who's the baddest? Us? Hello!"
            ]
        },
        { 
            type: 'PRE_CHORUS', 
            duration: 8, 
            rhythm: 'BUILDUP', 
            singer: 'ALL',
            lyrics: [
                "Knocking you out like a lullaby!",
                "Hear that sound ringing in your mind!",
                "Better sit down for the show!"
            ]
        },
        { 
            type: 'PRE_CHORUS', 
            duration: 2, 
            rhythm: 'BUILDUP', 
            singer: 'ALL',
            lyrics: ["'Cause I'm gonna show you!"]
        },
        { 
            type: 'PRE_CHORUS', 
            duration: 2, 
            rhythm: 'BUILDUP', 
            singer: 'MIRA',
            lyrics: ["I'm gonna show you!"]
        },
        { 
            type: 'PRE_CHORUS', 
            duration: 2, 
            rhythm: 'BUILDUP', 
            singer: 'ZOEY',
            lyrics: ["I'm gonna show you!"]
        },
        { 
            type: 'PRE_CHORUS', 
            duration: 2, 
            rhythm: 'BUILDUP', 
            singer: 'ALL',
            lyrics: ["How it's done, done, done!"]
        },
        { 
            type: 'BRIDGE', 
            duration: 4, 
            rhythm: 'TRAP', 
            singer: 'MIRA',
            lyrics: ["I don't talk, I bite! Full of venom!"]
        },
        { 
            type: 'BRIDGE', 
            duration: 4, 
            rhythm: 'TRAP', 
            singer: 'MIRA',
            lyrics: ["Spittin' facts! You know that's how it's done, done, done!"]
        },
        { 
            type: 'BRIDGE', 
            duration: 8, 
            rhythm: 'TRAP', 
            singer: 'ZOEY',
            lyrics: [
                "Okay, I know I ramble, but when shootin' my words, I go Rambo!",
                "Took blood and tears to look natural! That's how it's done, done, done!"
            ]
        },
        { 
            type: 'BRIDGE', 
            duration: 16, 
            rhythm: 'TRAP', 
            singer: 'RUMI',
            lyrics: [
                "Hear our voice unwavering till our song defeats the night.",
                "Making fear afraid to breathe till the dark meets the light!"
            ]
        },
        { 
            type: 'OUTRO', 
            duration: 32, 
            rhythm: 'ANTHEM', 
            singer: 'ALL',
            lyrics: [
                "How it's done, done, done!",
                "Run, run, we run the town! Whole world playing our sound!",
                "Turnin' up, it's goin' down! HUNTR/X show this how it's done, done, done!",
                "We hunt you down, down, down! We got you now, now, now!",
                "We show you how, how, how! HUNTR/X don't miss how it's done, done, done!"
            ]
        }
    ],
    musicalData: {
        keyRoot: "D",
        scale: "minor", 
        bpm: 160,
        defaultTheme: {
            chordProgression: [0, 5, 3, 4],
            bassPattern: [1, 0, 1, 0, 1, 0, 1, 0],
            melodyPattern: [0, 2, 4, 2, 0, null, null, null]
        },
        themes: {
            INTRO: {
                chordProgression: [0, 0, 0, 0],
                bassPattern: [1, 0, 0, 1, 1, 0, 0, 0], 
                melodyPattern: [12, null, 12, null, 7, 7, 0, 0, 12, null, 12, null, 14, 15, 12, 0]
            },
            VERSE: {
                chordProgression: [0, 2], 
                bassPattern: [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0], 
                melodyPattern: [0, 0, 0, 3, 0, null, -2, null, 0, 0, 0, 3, 0, null, null, null]
            },
            PRE_CHORUS: {
                chordProgression: [5, 6, 0, 4], 
                bassPattern: [1, 1, 1, 1, 1, 1, 1, 1], 
                melodyPattern: [5, 5, 7, 7, 8, 8, 10, 10, 12, 12, 12, 12, 14, 14, 15, 17]
            },
            CHORUS: {
                chordProgression: [5, 0, 2, 6], 
                bassPattern: [1, 0, 1, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 1, 1], 
                melodyPattern: [12, 12, 12, 7, 0, 7, 0, 7, 12, 12, 15, 14, 12, 7, 0, 0]
            },
            BRIDGE: {
                chordProgression: [0, 0], 
                bassPattern: [1, 0, 0, 0, 0, 0, 0, 0], 
                melodyPattern: [0, 2, 3, 5, 7, 8, 10, 12, null, null, null, null, null, null, null, null]
            },
            RAP_VERSE: {
                chordProgression: [0, 5],
                bassPattern: [1, 0, 0, 0, 1, 0, 0, 0, 1, 1, 0, 0, 1, 0, 1, 0],
                melodyPattern: [0, 0, 0, 0, 3, 0, null, null, 0, 0, 0, 0, 12, 0, null, null]
            },
            OUTRO: {
                 chordProgression: [5, 0, 2, 6],
                 bassPattern: [1, 0, 1, 0, 1, 0, 1, 0],
                 melodyPattern: [12, 12, 7, 7, 4, 4, 0, 0]
            }
        }
    }
};
